
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["initAuth","getVoiceTranscript","getTranscriptCorrected","getOnlyIfTranscriptCorrected","removeTranscriptCorrected","removeOldTranscriptCorrected","filterDeletedTextFromTranscript","addUIDToSource","saveToDB"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "10748255a132fbb6713e.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			